// Default theme settings configurations

export const ThemeSettingsConfig = {
  colorTheme: 'dark', // light, semi-light, semi-dark, dark
  layout: {
    style: 'horizontal', // style: 'vertical', horizontal,
    pattern: 'static' // fixed, boxed, static
  },
  menuColor: 'menu-dark', // Vertical: [menu-dark, menu-light] , Horizontal: [navbar-dark, navbar-light]
  navigation: 'menu-collapsible', // menu-collapsible, menu-accordation
  menu: 'expand', // collapse, expand
  header: 'fix', // fix, static
  footer: 'fix', // fix, static
  customizer: 'off', // on,off
  buybutton: 'off', // on, off
  headerIcons: {
    maximize: 'on', // on, off
    search: 'on', // on, off
    internationalization: 'off', // on, off
    notification: 'on', // on, off
    email: 'on' // on, off
  },
  brand: {
    brand_name: '',
    logo: {
      type: 'internal', // internal, url
      value: 'assets/custom/images/logo.png' // recommended location for custom images
      // type:'url',
      // value:'http://evolvision.com/wp-content/uploads/2018/01/envelope4-green.png'
    },
  },
  defaultTitleSuffix: 'PRISMA - Kino Grenzland Lichtspiele'
};
